export const theme = {
  colors: {
    blue: {
      1: '#A5D8FF',
      2: '#4DABF7',
      3: '#339AF0',
      4: '#228BE6',
      5: '#1C7ED6',
    },
    red: {
      1: '#FF8787',
      2: '#FA5252',
      3: '#F03E3E',
      4: '#E03131',
      5: '#C92A2A',
    },
    gray: {
      1: '#CED4DA',
      2: '#ADB5BD',
      3: '#868E96',
      4: '#828282',
      5: '#495057',
      6: '#343A40',
    },
    black: {
      1: '#212529',
    },
    purple: {
      1: '#9775FA',
      2: '#845EF7',
      3: '#7048E8',
    },
  },
  padding: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '32px',
    xxl: '64px',
  },
};

/*
Blue:
    - blue[3] for labels (Discovery, Sidebar etc)
    - blue[4] for buttons (plus, chat, etc) and tags to maintain continuity

Red:
    - red[4] for buttons (incomplete)
*/
